import { SPACING_DOUBLE, SPACING_HALF } from 'd2/constants'
import { appearFromSide } from 'd2/animations'
import { px } from 'd2/utils/style'
import makeStyles from 'd2/hooks/tss/makeStyles'

const {
  itemAnimationStyles,
} = appearFromSide()

const styles = () => ({
  chevron: {
    marginLeft: px(SPACING_HALF),
  },
  infoRow: {
    ...itemAnimationStyles,
    // Padding to make it easier to use the mouse to select the text without accidentally selecting the entire rest of the column.
    paddingLeft: px(SPACING_HALF),
    paddingRight: px(SPACING_HALF),
  },
  showMore: {
    margin: px(SPACING_DOUBLE),
  },
} as const)

export default makeStyles({
  name: 'CollapsibleAlbumMetadata',
})(styles)
